import type * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';

type ThisFieldTemplate = Pick<QuestionnaireApiModels.FieldTemplate, 'listFieldTemplateId' | 'type'>;

const getListOrTableField = <F extends ThisFieldTemplate>({
  fieldId,
  fieldsById,
}: {
  fieldId: string | undefined | null;
  fieldsById: Record<string, F>;
}): F | null => {
  if (!fieldId) {
    return null;
  }
  const currentField = fieldsById[fieldId];
  if (currentField?.type === 'list' || currentField?.type === 'table') {
    return currentField;
  }
  if (currentField?.listFieldTemplateId) {
    return getListOrTableField({
      fieldId: currentField.listFieldTemplateId,
      fieldsById,
    });
  }
  return null;
};

export default getListOrTableField;
